import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    section: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(2)
      }
    },
    field: {
      display: "flex !important",
      justifyContent: "center",
      marginBottom: theme.spacing(2),

      [theme.breakpoints.down("xs")]: {
        width: "100%"
      }
    }
  })
);
